import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { AdminXsMenu } from '../../component/admin/AdminXsMenu'
import { Box, Typography, Button } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import { PageContainer } from '../../component/styled/PageContainer'

export const WhatsappConfigScreen = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Whatsapp Config</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Box display='flex' my={3} justifyContent='space-between'>
          <Typography variant='h1'>Whatsapp Config</Typography>
          <AdminXsMenu />
        </Box>
        <Box display='flex' justifyContent='flex-end' mb={3}>
          <Button
            startIcon={<AddIcon style={{ color: 'white' }} />}
            variant='contained'
            color='primary'
            onClick={() => setOpen(true)}
          >
            Create
          </Button>
        </Box>
        <Table open={open} setOpen={setOpen} />
      </PageContainer>
    </>
  )
}
